import React from "react";
import { EWsrvTransform } from "../../lib/Media/util";
import ContentCardsBlade from "../Blades/ContentCardsBlade";
import { EListingCardLayouts, ListingCard } from "../Listing/ListingCard";
import { EListingVitalsLayout } from "../Listing/ListingVitals";
import { MarketStats } from "../MarketStats/MarketStats";
import { BackgroundImage } from "../Media/BackgroundImage";
import { Search } from "../Search/Search";
import { ICommunityLayoutProps } from "./util";

export const CommunityLayoutStandard: React.FC<ICommunityLayoutProps> = ({
    isTitleInHeading = false,
    title,
    description,
    heroBackgroundImageUrl,
    highlights,
    markets,
    marketReportBgImageUrl,
    listings,
    listingsResultPageSize = 20,
    listingsCardClass,
    listingsCardImageWidth,
    linkFunc,
    heroBackgroundImageProps,
    marketStatsProps,
    listingsResultCardsProps,
    listingsSearchProps,
    highlightsProps,
    communityVideo,
    neighborhoods,
    complexes,
}) => {

    const marketStats = markets && (
        <MarketStats
            markets={markets}
            title={`${title} Market Summary`}
            className="mx-auto"
            {...marketStatsProps}
        />
    )

    return (
        <>
            {heroBackgroundImageUrl && (
                <BackgroundImage
                    src={heroBackgroundImageUrl}
                    className="community-page-heading h-screen flex items-end justify-center"
                    sizesAndAspect={[
                        {
                            width: 420,
                            aspect: EWsrvTransform.cover3x2,
                        },
                        {
                            media: "min-width:420px",
                            width: 640,
                            aspect: EWsrvTransform.cover3x2,
                        },
                        {
                            media: "min-width:640px",
                            width: 768,
                            aspect: EWsrvTransform.cover3x2,
                        },
                        {
                            media: "min-width:768px",
                            width: 1024,
                            aspect: EWsrvTransform.cover3x2,
                        },
                        {
                            media: "min-width:1024px",
                            width: 1280,
                            aspect: EWsrvTransform.cover16x9,
                        },
                        {
                            media: "min-width:1280px",
                            width: 1440,
                            aspect: EWsrvTransform.cover16x9,
                        },
                    ]}
                    {...heroBackgroundImageProps}
                >
                    {isTitleInHeading &&
                        <h1
                            className={`community-name`}
                        >
                            {title}
                        </h1>
                    }
                </BackgroundImage>
            )}
            {!isTitleInHeading && (
                <h1
                    className={`community-name ${!heroBackgroundImageUrl ? "md:mt-28" : "mt-10"
                        }`}
                >
                    {title}
                </h1>
            )}
            {(description && !neighborhoods?.[0] && !complexes?.[0]) && (
                <div
                    className="max-w-screen-lg mx-auto p-8 community-description"
                    dangerouslySetInnerHTML={{
                        __html: description
                    }}
                />
            )}
            {(description && (neighborhoods?.[0] || complexes?.[0])) && (
                <div
                    className="flex flex-wrap lg:flex-nowrap max-w-screen-lg p-8 mx-auto mb-8 community-description gap-x-12 gap-y-8"
                >
                    <div 
                        className="w-full lg:w-3/5 lg:text-left"
                        dangerouslySetInnerHTML={{
                        __html: description
                    }}
                    />
                    <div className="w-full lg:w-2/5 flex flex-col lg:text-left gap-2">
                        {neighborhoods?.[0] &&
                            <>
                                <h3>Neighborhoods:</h3>
                                {neighborhoods.map((n: any, index: number) => (
                                    linkFunc!({ href: n.path, children: n.name, key: index, className: "!text-accent" })
                                ))}
                            </>
                        }
                        {complexes?.[0] &&
                            <>
                                <h3>Complexes:</h3>
                                {complexes.map((n: any, index: number) => (
                                    linkFunc!({ href: n.path, children: n.name, key: index, className: "!text-accent" })
                                ))}
                            </>
                        }
                        {highlights && highlights.length > 0 && (
                            <ContentCardsBlade
                                className={`community-highlights w-full !flex !flex-col lg:text-left lg:items-start !gap-2 xl:[&_>_article_>_*]:px-0`}
                                contentCards={highlights}
                                {...highlightsProps}
                            >
                            </ContentCardsBlade>
                        )}
                    </div>
                </div>
            )}
            {communityVideo?.url && 
                <section className="relative max-w-screen-xl w-full mx-auto pb-8">
                    <video
                        className="w-full aspect-[16/9]"
                        controls
                        playsInline
                        src={`${communityVideo.url}#t=0.001`}
                    ></video>
                </section>
            }
            {(highlights && highlights.length > 0 && !neighborhoods?.[0] && !complexes?.[0]) && (
                <ContentCardsBlade
                    className={`community-highlights max-w-screen-lg mx-auto`}
                    contentCards={highlights}
                    {...highlightsProps}
                >
                </ContentCardsBlade>
            )}
            {marketStats && marketReportBgImageUrl && (
                <div style={{ textShadow: "1px 1px 2px #3c3c3c" }}>
                    <BackgroundImage
                        src={marketReportBgImageUrl}
                        className="p-12 inverted"
                        sizesAndAspect={[
                            {
                                width: 420,
                                aspect: EWsrvTransform.cover2x6,
                            },
                            {
                                media: "min-width:420px",
                                width: 640,
                                aspect: EWsrvTransform.cover2x6,
                            },
                            {
                                media: "min-width:640px",
                                width: 768,
                                aspect: EWsrvTransform.cover3x2,
                            },
                            {
                                media: "min-width:768px",
                                width: 1024,
                                aspect: EWsrvTransform.cover3x2,
                            },
                            {
                                media: "min-width:1024px",
                                width: 1280,
                                aspect: EWsrvTransform.cover16x9,
                            },
                            {
                                media: "min-width:1280px",
                                width: 1440,
                                aspect: EWsrvTransform.cover16x9,
                            },
                        ]}
                    >
                        {marketStats}
                    </BackgroundImage>
                </div>
            )}
            {marketStats &&
                !marketReportBgImageUrl &&
                marketStats}
            {listings && listings.length > 0 && (
                <>
                    <a id="listings" />
                    <Search
                        index={listings}
                        className="community-search"
                        pageSize={listingsResultPageSize}
                        pageSizeOpts={[
                            listingsResultPageSize * 1,
                            listingsResultPageSize * 2,
                            listingsResultPageSize * 3,
                            listingsResultPageSize * 4,
                        ]}
                        pagerBottom={true}
                        showCount={true}
                        useMap={true}
                        renderItem={(item, index) => {
                            return (
                                <ListingCard
                                    listing={item}
                                    layout={EListingCardLayouts.vertical}
                                    className={`${listingsCardClass} max-w-full`}
                                    maxWidthImage={listingsCardImageWidth}
                                    vitalsLayout={EListingVitalsLayout.column2Border1}
                                    linkImage={true}
                                    key={index}
                                    linkFunc={linkFunc}
                                    {...listingsResultCardsProps}
                                />
                            )
                        }}
                        {...listingsSearchProps}
                    />
                </>
            )}
        </>
    )
}

export default CommunityLayoutStandard